'use client';

import { useSubsidiaryFilterOptional } from '@/@subsidiary/context';
import { useMemo } from 'react';

const EMPTY_ORG_IDS: number[] = [];

/**
 * Stable org-id list for API filters (crosstabs, surveys, etc.).
 * Depends on primitives only so unrelated SubsidiaryFilter context updates
 * (e.g. isLoading) do not allocate a new array / invalidate query keys.
 */
export function useSubsidiaryOrgIds(): number[] {
    const filter = useSubsidiaryFilterOptional();
    const selectedOrgIds = filter?.selectedOrgIds;
    const isInternal = filter?.isInternal === true;
    const options = filter?.options;

    return useMemo(() => {
        if (selectedOrgIds?.length) return selectedOrgIds;
        if (!isInternal && options?.length) {
            return options.map((o) => o.orgId);
        }
        return EMPTY_ORG_IDS;
    }, [selectedOrgIds, isInternal, options]);
}
